export const shortDate = (longDate) => (longDate ? longDate.slice(0, 10) : '-')

export const getTimeFromDate = (date) => (date ? date.slice(12, 20) : '-')
